<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="3" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Add VIP Level
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name"
                prepend-inner-icon="mdi-format-letter-case"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.level"
                outlined
                label="Level"
                type="number"
                prepend-inner-icon="mdi-stairs-up"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.cost_in_coins"
                outlined
                label="Cost in Coins"
                type="number"
                prepend-inner-icon="mdi-cash-multiple"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.duration_days"
                outlined
                type="number"
                label="Duration Days"
                prepend-inner-icon="mdi-calendar-range"
              ></v-text-field>
            </v-col>
            <v-col sm="8">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-text"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="position"
                outlined
                v-model="form.privileges"
                :items="privilegesItems"
                item-text="title"
                item-value="id"
                label="Privileges *"
                prepend-inner-icon="mdi-account-tie-outline"
                multiple
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save VIP Level
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "VipLevelCreatePage",
  data() {
    return {
      form: {
        company_id: 1,
        name: "",
        level: "",
        cost_in_coins: "",
        privileges: [], // yaha output ayega array me
      },
      privilegesItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getPrivileges();
  },
  methods: {
     async getPrivileges() {
      try {
        let response = await axios.get(`/vip_privileges`);
        this.privilegesItems = response.data.data;
      } catch (error) {
        console.error("Error fetching privileges:", error);
      }
    },
    async save() {
      try {
        this.isLoading = true;
        console.log("Form Data:", this.form);
        await axios.post("/vip_levels", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/vip-levels");
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
